import * as z from 'zod';

export const hostingManagementQuerySchema = z.enum(['internal', 'external', 'external-no-access']);

type HostingManagementQuerySchema = z.infer<typeof hostingManagementQuerySchema>;
export type HostingManagementMutationSchema = HostingManagementQuerySchema;

export const hostingManagementFormSchema = z.object({
  name: z.string(),
  value: hostingManagementQuerySchema,
});

type HostingManagementFormSchema = z.infer<typeof hostingManagementFormSchema>;

export const defaultHostingManagement = null;

export const hostingManagementOptions: HostingManagementFormSchema[] = [
  { name: 'Internal', value: 'internal' },
  { name: 'External (We Can Access)', value: 'external' },
  { name: 'External (No Access)', value: 'external-no-access' },
];

export function strToHostingManagement(
  hostingManagement: HostingManagementQuerySchema | null
): HostingManagementFormSchema | null {
  return hostingManagementOptions.find((option) => option?.value === hostingManagement) ?? null;
}

export function hostingManagementToStr(
  hostingManagement?: HostingManagementFormSchema | null
): HostingManagementQuerySchema | null {
  return hostingManagement?.value ?? null;
}
